import React from 'react';
import classnames from 'classnames';

const Discount = (props) => {
  const { label, value, subtotal, alwaysShow } = props;
  if (!alwaysShow && (value === undefined || value == null)) return null;

  return (
    <>
      <div>
        <span className="cart-property">Subtotal:</span>
        <span className="cart-amount order-subtotal"> {subtotal}</span>
      </div>
      <div>
        <span className="cart-property">{label || 'Discount'}:</span>
        <span className="cart-amount product-discount"> {value}</span>
      </div>
    </>
  );
};

/**
 * This component just displays data, without validation logic.
 */
const ProductCartForm = (props) => {
  const {
    properties = [],
    unitPrice,
    totalPrice,
    discountLabel,
    discountValue,
    discountSubtotal,
    discountAlwaysShow,
    onAddToCart,
    addingToCart,
  } = props;

  const onClick = () => {
    if (onAddToCart) {
      onAddToCart();
    }
  };

  const unitPriceKlass = classnames(
    'cart-amount product-unit-price',
    {
      discounted: discountValue,
    },
  );

  return (
    <div className="inside-product-cart">
      <span className="selection-label">Pricing Information</span>
      <hr className="qty-separator" />

      {properties.map((p, idx) => (
        <div key={idx} className="row g-0 align-items-center product-property pe-2 mb-2">
          <div className="col-auto">
            <span className="product-property-label">{p.label}</span>
          </div>
          <div className="col-auto">
            <span className="product-property-value">{p.value}</span>
          </div>
        </div>
      ))}

      <div className="inside-product-cart-b pb-2">
        <hr className="product-unit-price-separator" />
        <div className="clearfix">
          <span className="cart-property">Unit Price:</span>
          <span className={unitPriceKlass}> {unitPrice}</span>
        </div>
        <Discount
          label={discountLabel}
          value={discountValue}
          subtotal={discountSubtotal}
          alwaysShow={discountAlwaysShow} />
        <hr className="product-total-separator" />
        <div className="total">
          <span className="product-total-label">Total:</span>
          <span className="product-total"> {totalPrice}</span>
        </div>
      </div>
      <div className="text-center">
        <button
          type="button"
          className="btn btn-primary btn-round w-100"
          onClick={onClick}
          disabled={addingToCart}>
          {addingToCart && <span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />}
          {addingToCart ? Spree.translations.adding_to_cart : Spree.translations.add_to_cart}
        </button>
      </div>
    </div>
  );
};

export default ProductCartForm;
